export default [
  //! ENGLISH DATA
  {
    navButton: `Join Now`,

    //? Change the "href" attribute of the JOIN NOW button for the app
    headingOne: ` 
    <div class="first-header header">
        <span>Learning</span> 
        <span>English</span> 
        <span>happens</span>
        <span>socially:</span>
        <span class="secondary-color">connect,</span>
        <span class="secondary-color">practice,</span>
        <span>and</span>
        <span class="secondary-color">grow</span> 
        <span> with</span>
        <span class="secondary-color">PeakSynap!</span>
      </div>

      <div class="second-header header">
          <span>
            Join the Beta experience this 
            <span class="secondary-color">
              Coming soon!
            </span>
          </span>
      </div>

      <a href="#" disabled="true" class="beta-btn">Join the Beta</a>

      <div class="circle">
        <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#044336"></path> </g></svg>
      </div>`,
    headingTwo: `  <div class="description ">
        <div class="first-about">

          <span class="secondary-color">PeakSynap</span> is the social network where Learning English becomes a social experience.
        </br>
        </br>

          Connect with mentors, creators and learners worldwide while enjoying focused content designed to motivate and adapt to your level.
        </div>
        <div class="second-about">
          Unlike other platforms, <span class="secondary-color">PeakSynap</span> combines learning and social connection, offering innovative and accessible tools that make improving English as intuitive as it's enjoyable. 
        </br>
        </br>
          <span class="secondary-color">Learn,</span>  <span class="secondary-color">collaborate,</span> and <span class="secondary-color">grow</span> in an inspiring environment.
        </div>
      </div>`,
    headingThree: `
      <div class="monetize-main-con">
        <div class="monetize-inner-con">
          <div class="monetize">Selling exclusive and on-demand educational content.</div>
          <div class="monetize monetize-margin">Multilevel follower subscriptions.</div>
        </div>
        <div class="monetize-inner-con">
          <div class="monetize">Paid group management with access to exclusive content and communities.</div>
          <div class="monetize monetize-margin">Scheduling individual or group learning sessions.</div>
        </div>
        <div class="monetize">Support gifts from followers during live streams or directly to the profile.</div>
      </div>
    `,
    headingFour: `
       <div class="target-segment">
        <div class="target-title">For the <span class="secondary-color">Learners</span></div>
        <div class="target-description">
          At <span class="secondary-color">PeakSynap</span>, learning English is simple and fun. Download the app, sign up, and personalize your profile with your interests and skills. Explore focused English content in various formats like short videos, complete lessons, and live streams. Use tools like the glossary and translator to expand your vocabulary, save favorite videos, and socialize by commenting and reacting to content. Join groups and participate in challenges to practice with other learners who share your interests. Track your progress as <span class="secondary-color">PeakSynap</span> records your achievements and adapts content to your level, motivating you to keep improving.
        </div>
      </div>
    `,

    headingFive: `
      <div class="target-segment">
        <div class="target-title">For the <span class="secondary-color">Mentors</span></div>
        <div class="target-description">
          Your knowledge has the perfect space to grow and generate income. Share your expertise through focused content like courses, e-books, and live streams. Monetize easily with periodic subscriptions, private classes, and direct support from learners in your community. Build your professional network by connecting with interested learners and inspiring mentors. Integrated tools like content analytics and schedule management help optimize your reach and strengthen your presence as a leader in teaching English.
        </div>
      </div>
    `,

    headingSix: `
       <div class="target-segment">
        <div class="target-title">For the <span class="secondary-color">Content Creators</span></div>
        <div class="target-description">
          Your creativity drives learning. Share unique and specialized content such as videos, digital courses, or focused books, and connect with an audience that values your talent. Monetize your creations with direct sales, subscriptions, and live streams while inspiring a committed learning community. Highlight your work and grow your visibility by joining the <span>Beta program.</span>
        </div>
      </div>
    `,

    headingSeven: `
       <div class="target-segment">
        <div class="target-title">For the <span class="secondary-color">Educational Institutions</span></div>
        <div class="target-description">
          Perfect tools to manage educational social networks that effectively connect students and teachers. Facilitate English teaching in a structured environment, leveraging features to socialize learning and strengthen community interaction. Optimize learning with innovative tools and foster authentic connections among your students and educators.
        </div>
      </div>
    `,

    headingEighth: `
      <div class="target-segment">
        <div class="target-title">For the <span class="secondary-color">Businesses</span></div>
        <div class="target-description">
          Connect your brand with a global community of learners interested in learning English. Leverage this active and engaged audience to position your business in the educational and language niche. Use real-time metrics to measure campaign reach and maximize your impact in a growing market.
        </div>
      </div>
    `,

    discoverPeakSynap: `
    <div class="app">
            <div class="app-socials-title">Discover <span class="secondary-color">PeakSynap!</span></div>
            <div class="app-socials-description">Learn English like never before! Connect with mentors, creators, and learners worldwide while enjoying engaging, level-adaptive content. PeakSynap makes learning social, intuitive, and fun.
              <br>
              <br>
  Download now and start your journey! </div>
            <div class="app-sub-con">
              <a href="https://www.apple.com/app-store/">
                <img src="/textures/app-store.png" alt="">
              </a>
              <a href="https://play.google.com/store/apps?hl=en">
                <img src="/textures/google-store.png" alt="">
              </a>
            </div>
          </div>
    `,
    faqTitle: `
    The 10 Most Frequently Asked Questions for New
          <span>PeakSynap</span> Users
    `,

    //! links to the socials change the "href" attribute of the <a> elements
    socialsPeakSynap: `
     <div class="socials">
          <div class="app-socials-title">
            Join the <span class="secondary-color">PeakSynap</span> Community
          </div>
          <div class="app-socials-description">
            Stay engaged beyond the app! Follow us on social media for exclusive
            updates, learning tips, and inspiration from fellow learners.
            Connect, grow, and make English learning a social experience!
          </div>
        </div>

        <div class="socials-sub-con">

      
          <a href="https://www.facebook.com/peaksynap/">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g clip-path="url(#clip0_17_61)">
                <path
                  d="M24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24C48 10.7453 37.2547 0 24 0Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_61">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>

         
          <a href="https://www.instagram.com/peaksynap/">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <g clip-path="url(#clip0_17_63)">
                <path
                  d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
                />
                <path
                  d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
                />
                <path
                  d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_63">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>

  
          <a href="https://www.linkedin.com/in/peaksynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g clip-path="url(#clip0_17_68)">
                <path
                  d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4062 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4062 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39062 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39062 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_68">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>
       
          <a href="https://x.com/PeakSynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M36.6526 3.8078H43.3995L28.6594 20.6548L46 43.5797H32.4225L21.7881 29.6759L9.61989 43.5797H2.86886L18.6349 25.56L2 3.8078H15.9222L25.5348 16.5165L36.6526 3.8078ZM34.2846 39.5414H38.0232L13.8908 7.63406H9.87892L34.2846 39.5414Z"
              />
            </svg>
          </a>

     
          <a href="https://www.tiktok.com/@peaksynap?lang=en">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z"
              />
            </svg>
          </a>

     
          <a href="https://www.youtube.com/@PeakSynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M47.5219 14.4001C47.5219 14.4001 47.0531 11.0907 45.6094 9.6376C43.7812 7.7251 41.7375 7.71572 40.8 7.60322C34.0875 7.11572 24.0094 7.11572 24.0094 7.11572H23.9906C23.9906 7.11572 13.9125 7.11572 7.2 7.60322C6.2625 7.71572 4.21875 7.7251 2.39062 9.6376C0.946875 11.0907 0.4875 14.4001 0.4875 14.4001C0.4875 14.4001 0 18.2907 0 22.172V25.8095C0 29.6907 0.478125 33.5813 0.478125 33.5813C0.478125 33.5813 0.946875 36.8907 2.38125 38.3438C4.20937 40.2563 6.60938 40.1907 7.67813 40.397C11.5219 40.7626 24 40.8751 24 40.8751C24 40.8751 34.0875 40.8563 40.8 40.3782C41.7375 40.2657 43.7812 40.2563 45.6094 38.3438C47.0531 36.8907 47.5219 33.5813 47.5219 33.5813C47.5219 33.5813 48 29.7001 48 25.8095V22.172C48 18.2907 47.5219 14.4001 47.5219 14.4001ZM19.0406 30.2251V16.7345L32.0062 23.5032L19.0406 30.2251Z"
              />
            </svg>
          </a>
        </div>
    `,

    //? contact titles
    contactTitle: `
      Contact <span class="secondary-color">Us</span></div>
    `,
    contactName: `Name:`,
    contactEmail: `Email:`,
    contactPhone: `Phone Number:`,
    contactMessage: `Your Message:`,
    contactUs: "Contact Us",
  },

  //! SPANISH DATA
  {
    navButton: `Unirse`,

    //? Change the "href" attribute of the JOIN NOW button for the app
    headingOne: `  <div class="first-header header first-move">
     <span>Porque</span> 
      <span>el</span> 
        <span>Aprender</span> 
        <span>inglés</span>
        <span>es una</span>
        <span>experiencia</span>
        <span>social:</span>
        <span class="secondary-color">conecta,</span>
        <span class="secondary-color">practica</span>
        <span>y</span>
        <span class="secondary-color">crece</span>
        <span>con</span>
        <span class="secondary-color">PeakSynap.</span>


      </div>

      <div class="second-header header">
          <span>
            Únete a la experiencia Beta
            <span class="secondary-color">
             Proximamente.
            </span>
          </span>
      </div>

       <a href="#" class="beta-btn">Únete al Beta
      </a>


      <div class="circle">
        <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#044336"></path> </g></svg>
      </div>`,

    headingTwo: `  <div class="description ">
        <div class="first-about">

          <span class="secondary-color">PeakSynap</span> es la red social donde aprender inglés se convierte en una experiencia social.
        </br>
        </br>

          Aquí, conectas con mentores, creadores y aprendices de todo el mundo mientras disfrutas contenido enfocado diseñado para motivarte y adaptarse a tu nivel.  
        </div>
        <div class="second-about">
          A diferencia de otras plataformas, <span class="secondary-color">PeakSynap</span> combina aprendizaje y conexión social, ofreciéndote herramientas innovadoras y accesibles que hacen que mejorar tu inglés sea tan intuitivo como placentero. 
        </br>
        </br>
          <span class="secondary-color">Aprende,</span>  <span class="secondary-color">colabora</span> y <span class="secondary-color">crece</span> en un entorno que te inspira a alcanzar tus metas. 🌟💬
        </div>
      </div>`,
    headingThree: `
      <div class="monetize-main-con">
        <div class="monetize-inner-con">
          <div class="monetize">Venta de contenido educativo exclusivo</div>
          <div class="monetize monetize-margin">Suscripciones de seguidores con membresías multinivel.</div>
        </div>
        <div class="monetize-inner-con">
          <div class="monetize">Gestión de Grupos de paga con acceso a contenido y comunidades exclusivas!</div>
          <div class="monetize monetize-margin">“Se Busca, Se Ofrece”: Agenda de sesiones individuales o grupales de aprendizaje.</div>
        </div>
        <div class="monetize">Recibe regalos de apoyo de tus seguidores durante transmisiones en vivo o directo al perfil.</div>
      </div>
    `,
    headingFour: `
       <div class="target-segment">
        <div class="target-title">Para <span class="secondary-color">Aprendices</span></div>
        <div class="target-description">
          En <span class="secondary-color">PeakSynap</span>, aprender inglés es sencillo y divertido. Solo necesitas descargar la app, registrarte y personalizar tu perfil con tus intereses y habilidades. Desde ahí, puedes explorar contenido enfocado en inglés en diferentes formatos como videos cortos, lecciones completas y transmisiones en vivo. Usa herramientas como el glosario y el traductor para ampliar tu vocabulario, guarda tus videos favoritos y socializa comentando y reaccionando al contenido. También puedes unirte a grupos y participar en retos para practicar con otros aprendices que comparten tus intereses. A medida que avanzas, <span class="secondary-color">PeakSynap</span> registra tus logros y adapta el contenido según tu nivel, motivándote a seguir mejorando. Aquí, aprender inglés es una experiencia social que te conecta con una comunidad que te inspira a crecer. 🌟💬
        </div>
      </div>
    `,
    headingFive: `
      <div class="target-segment">
        <div class="target-title">Oportunidades para <span class="secondary-color">Mentores</span></div>
        <div class="target-description">
            En <span class="secondary-color">PeakSynap</span>, tu conocimiento tiene el espacio perfecto para crecer y generar ingresos. Comparte tu experiencia a través de contenido enfocado, como cursos, libros digitales y transmisiones en vivo. Monetiza fácilmente con suscripciones periódicas, clases privadas y el apoyo directo de aprendices en tu comunidad.
Además, puedes construir tu red profesional conectando con aprendices interesados en tu especialidad y otros mentores que te inspiren. Con herramientas integradas como análisis de contenido y gestión de horarios, <span class="secondary-color">PeakSynap</span> te ayuda a optimizar tu alcance y fortalecer tu presencia como líder en la enseñanza del inglés.


        </div>
      </div>
    `,

    headingSix: `
       <div class="target-segment">
        <div class="target-title">Oportunidades para <span class="secondary-color">Creadores de contenido</span></div>
        <div class="target-description">
          En <span class="secondary-color">PeakSynap</span>, tu creatividad es el motor del aprendizaje. Comparte contenido único y especializado, como videos, cursos digitales o libros enfocados, y conecta con una audiencia que valora tu talento. Monetiza tus creaciones con ventas directas, suscripciones y transmisiones en vivo mientras inspiras a una comunidad comprometida con el aprendizaje.
Este es el momento de destacar en el nicho educativo. Únete al <span class="secondary-color">programa Beta</span> y sé parte de los primeros en construir tu audiencia, ganar visibilidad y dejar tu marca en un espacio diseñado para creadores innovadores como tú.
        </div>
      </div>
    `,

    headingSeven: `
       <div class="target-segment">
        <div class="target-title">Oportunidades para <span class="secondary-color">Entidades Educativas</span></div>
        <div class="target-description">
          En <span class="secondary-color">PeakSynap</span>, las instituciones tienen las herramientas perfectas para gestionar redes sociales educativas que conecten a estudiantes y profesores de manera efectiva. Facilita la enseñanza del inglés en un entorno estructurado, aprovechando nuestras funcionalidades para socializar el aprendizaje y fortalecer la interacción en comunidad.
          Desde la gestión de grupos y sesiones en vivo hasta la creación de contenido enfocado, <span class="secondary-color">PeakSynap</span> apoya a las instituciones en su misión de formar estudiantes preparados para un mundo globalizado. Optimiza el aprendizaje con herramientas innovadoras y fomenta conexiones auténticas entre tus alumnos y docentes.
        </div>
      </div>
    `,

    headingEighth: `
      <div class="target-segment target-segment-fifth">
        <div class="target-title">Oportunidades para <span class="secondary-color">Empresas</span></div>
        <div class="target-description">
          En <span class="secondary-color">PeakSynap</span>, conectamos a tu marca con una comunidad global de miles de aprendices interesados en el aprendizaje del inglés. Aprovecha esta audiencia activa y comprometida para posicionar tu negocio en el nicho educativo y de idiomas.
          Nuestra plataforma te ofrece herramientas para llegar directamente a tu público objetivo mediante colaboraciones estratégicas y contenido enfocado. Además, con métricas en tiempo real, podrás medir el alcance de tus campañas y maximizar tu impacto en un mercado en constante crecimiento.
        </div>
      </div>
    `,

    discoverPeakSynap: `
          <div class="app">
            <div class="app-socials-title">Descubre <span class="secondary-color">PeakSynap!</span></div>
            <div class="app-socials-description">¡Aprende inglés como nunca antes! Conecta con mentores, creadores y aprendices alrededor del mundo mientras disfrutas interactuando con contenido que se ajusta a tu nivel. PeakSynap hace el aprendizaje social intuitivo y divertido
              <br>
              <br>
              ¡Descarga ahora y empieza tu viaje! 
            </div>
            <div class="app-sub-con">
              <a href="https://www.apple.com/app-store/">
                <img src="/textures/app-store.png" alt="">
              </a>
              <a href="https://play.google.com/store/apps?hl=en">
                <img src="/textures/google-store.png" alt="">
              </a>
            </div>
          </div>
    `,

    faqTitle: `
    Las 10 preguntas más frecuentes de usuarios nuevos de
          <span>PeakSynap</span>
    `,

    //? links to the socials change the "href" attribute of the <a> elements
    socialsPeakSynap: `
     <div class="socials">
          <div class="app-socials-title">
            Únete a la comunidad de <span class="secondary-color">PeakSynap</span>
          </div>
          <div class="app-socials-description">
            Mantente conectado con nosotros más allá de la app! 
            Síguenos en redes sociales para actualizaciones exclusivas, tips de aprendizaje e Inspiración de compañeros aprendices. 
            ¡Conecta, crece y haz que aprender inglés sea una experiencia social!
          </div>
        </div>

        <div class="socials-sub-con">
          <a href="https://www.facebook.com/peaksynap/">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g clip-path="url(#clip0_17_61)">
                <path
                  d="M24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24C48 10.7453 37.2547 0 24 0Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_61">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>
       
          <a href="https://www.instagram.com/peaksynap/">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <g clip-path="url(#clip0_17_63)">
                <path
                  d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
                />
                <path
                  d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
                />
                <path
                  d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_63">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>
         
          <a href="http://www.linkedin.com/in/peaksynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g clip-path="url(#clip0_17_68)">
                <path
                  d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4062 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4062 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39062 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39062 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
                />
              </g>
              <defs>
                <clipPath id="clip0_17_68">
                  <rect width="48" height="48" />
                </clipPath>
              </defs>
            </svg>
          </a>
       
          <a href="https://x.com/PeakSynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M36.6526 3.8078H43.3995L28.6594 20.6548L46 43.5797H32.4225L21.7881 29.6759L9.61989 43.5797H2.86886L18.6349 25.56L2 3.8078H15.9222L25.5348 16.5165L36.6526 3.8078ZM34.2846 39.5414H38.0232L13.8908 7.63406H9.87892L34.2846 39.5414Z"
              />
            </svg>
          </a>
        
          <a href="https://www.tiktok.com/@peaksynap?lang=en">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z"
              />
            </svg>
          </a>
       
          <a href="https://www.youtube.com/@PeakSynap">
            <svg
              class="social-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M47.5219 14.4001C47.5219 14.4001 47.0531 11.0907 45.6094 9.6376C43.7812 7.7251 41.7375 7.71572 40.8 7.60322C34.0875 7.11572 24.0094 7.11572 24.0094 7.11572H23.9906C23.9906 7.11572 13.9125 7.11572 7.2 7.60322C6.2625 7.71572 4.21875 7.7251 2.39062 9.6376C0.946875 11.0907 0.4875 14.4001 0.4875 14.4001C0.4875 14.4001 0 18.2907 0 22.172V25.8095C0 29.6907 0.478125 33.5813 0.478125 33.5813C0.478125 33.5813 0.946875 36.8907 2.38125 38.3438C4.20937 40.2563 6.60938 40.1907 7.67813 40.397C11.5219 40.7626 24 40.8751 24 40.8751C24 40.8751 34.0875 40.8563 40.8 40.3782C41.7375 40.2657 43.7812 40.2563 45.6094 38.3438C47.0531 36.8907 47.5219 33.5813 47.5219 33.5813C47.5219 33.5813 48 29.7001 48 25.8095V22.172C48 18.2907 47.5219 14.4001 47.5219 14.4001ZM19.0406 30.2251V16.7345L32.0062 23.5032L19.0406 30.2251Z"
              />
            </svg>
          </a>
        </div>
    `,

    //? contact titles
    contactTitle: `
      Contáctanos
    `,
    contactName: `Nombre:`,
    contactEmail: `Correo Electrónico:`,
    contactPhone: `Teléfono:`,
    contactMessage: `Tu Mensaje:`,
    contactUs: "Contáctanos",
  },
];
